export default function PHP_json_encode() {
  return (
    <div>
      <h1>PHP_json_encode</h1>
    </div>
  );
}
